{
  "title": "Payments",
  "subtitle": "Every payment, refund and void, with what came in per method.",
  "providers": {
    "test": "Test payment provider"
  },
  "kinds": {
    "payment": "Payment",
    "refund": "Refund",
    "void": "Void"
  },
  "card": {
    "title": "Payments",
    "total": "Total",
    "paid": "Paid",
    "refunded": "Refunded",
    "due": "Still due",
    "codTitle": "Delivered, waiting for the courier",
    "codText": "The courier collected the cash: record its settlement when it pays in.",
    "codLink": "Record the settlement",
    "draft": "Payments come once the order is placed.",
    "none": "No payment yet."
  },
  "entry": {
    "settled": "Courier settlement",
    "voided": "Voided",
    "refunded": "Refunded",
    "refundedPart": "{{amount}} refunded",
    "cash": "Handed over {{tendered}}, change {{change}}",
    "left": "{{amount}} left to refund",
    "actions": "Actions on this payment"
  },
  "take": {
    "action": "Take payment",
    "title": "Payment for {{number}}",
    "due": "Still due: {{amount}}. Several payments make a split payment.",
    "method": "Payment method",
    "amount": "Amount",
    "tooMuch": "More than the {{amount}} still due",
    "tendered": "Cash handed over",
    "tenderedHint": "Leave empty when it is the exact amount.",
    "references": {
      "card": "Card slip number",
      "cheque": "Cheque number",
      "transfer": "Transfer reference"
    },
    "bank": "Bank",
    "chequeDate": "Date on the cheque",
    "change": "Change to give back",
    "note": "Note",
    "confirm": "Record {{amount}}",
    "doneLeft": "Payment recorded, {{amount}} still due",
    "donePaid": "Order {{number}} is paid"
  },
  "refund": {
    "action": "Refund",
    "title": "Refund a payment",
    "of": "{{method}} payment of {{amount}}, {{date}}. The money goes back the way it came.",
    "amount": "Amount to give back",
    "left": "Up to {{amount}} on this payment.",
    "tooMuch": "More than the {{amount}} left on this payment",
    "for": "For",
    "noReturn": "No return (a gesture, a price correction)",
    "return": "The return of {{date}} · {{reason}}",
    "creditNote": "The order has an invoice: this refund gets its own credit note.",
    "note": "Note",
    "confirm": "Refund",
    "done": "{{amount}} refunded",
    "provider": "The payment provider gives the money back to the customer's card."
  },
  "void": {
    "action": "Void",
    "title": "Void the {{method}} payment of {{amount}}?",
    "text": "For a payment taken by mistake. It stays in the journal, marked voided, and no longer counts.",
    "reason": "Why",
    "confirm": "Void the payment",
    "done": "Payment voided"
  },
  "invoice": {
    "action": "Issue invoice",
    "title": "Invoice for {{number}}",
    "fromCustomer": "The buyer's details come from the customer record. Type others to replace them on this invoice.",
    "noCustomer": "The order has no customer: type the buyer's details.",
    "final": "An invoice is final: it gets the next number and only its date can still change. Returns and refunds after it get credit notes.",
    "buyerName": "Buyer",
    "buyerTaxId": "Buyer's tax ID",
    "buyerAddress": "Buyer's address",
    "confirm": "Issue the invoice",
    "done": "Invoice {{number}} issued",
    "date": "Invoice date",
    "dateHint": "Not before the last invoice: dates follow the numbers."
  },
  "documents": {
    "title": "Documents",
    "none": "No invoice yet. Issue one when the customer asks for it."
  },
  "cod": {
    "title": "Cash on delivery",
    "subtitle": "Delivered orders whose cash the courier still has. Record what it pays in.",
    "emptyTitle": "Nothing waiting",
    "emptyText": "Every cash on delivery order is settled.",
    "pending_one": "{{count}} order · {{amount}} to collect",
    "pending_other": "{{count}} orders · {{amount}} to collect",
    "carrier": "Courier",
    "allCarriers": "All couriers",
    "noCarrier": "No courier",
    "carrierCount": "{{name}} ({{count}})",
    "pickCarrier": "Choose the courier",
    "noCarriers": "No carrier collects cash on delivery yet: add one in Configuration › Carriers.",
    "pickAll": "Tick all shown",
    "pick": "Tick {{number}}",
    "late_one": "{{count}} day",
    "late_other": "{{count}} days",
    "shipped": "shipped {{date}}",
    "amountOf": "Amount paid in for {{number}}",
    "amountWrong": "Between 0 and {{amount}}",
    "settlement": "Settlement",
    "settlementHint": "One settlement per courier statement: each ticked order gets its payment.",
    "reference": "Statement reference",
    "referenceHint": "The courier's statement or transfer number.",
    "receivedOn": "Received on",
    "orders_one": "{{count}} order",
    "orders_other": "{{count}} orders",
    "confirm": "Record the settlement",
    "done_one": "{{amount}} from {{carrier}} recorded on {{count}} order",
    "done_other": "{{amount}} from {{carrier}} recorded on {{count}} orders"
  },
  "journal": {
    "from": "From",
    "to": "To",
    "method": "Method",
    "allMethods": "All methods",
    "site": "Site",
    "allSites": "All sites",
    "clear": "Clear filters",
    "inOut": "In {{received}} · out {{refunded}}",
    "net": "Net received",
    "noMatch": "No payment matches these filters",
    "emptyTitle": "No payment yet",
    "emptyText": "Payments recorded on orders appear here.",
    "columns": {
      "when": "When",
      "order": "Order",
      "what": "What",
      "reference": "Reference",
      "site": "Site",
      "by": "By",
      "amount": "Amount (TND)"
    },
    "more": "Show more"
  },
  "customer": {
    "title": "Record a payment",
    "date": "Date",
    "dateHint": "The day the money came in.",
    "tillDate": "A register takes today’s money.",
    "orders": "Orders it pays",
    "ordersHint": "Tick orders and the amount follows, or type the amount and share it over the oldest.",
    "shareOldest": "Share over the oldest",
    "openAmount": "{{amount}} still due",
    "shareOf": "Share of {{number}}",
    "otherMethod": "This order does not take this method",
    "shared": "Shared",
    "toShare": "Still to share",
    "overShared": "More than the amount",
    "noAdvance": "All of it goes to orders: a customer does not hold an advance.",
    "done_one": "Payment recorded on {{count}} order",
    "done_other": "Payment recorded on {{count}} orders",
    "voidText": "For a payment taken by mistake. It comes off every order it paid, stays in the journal marked voided, and no longer counts."
  }
}
